import { NgFor } from '@angular/common';
import {
  Component,
  effect,
  forwardRef,
  input,
  model,
  OnInit,
  Type,
} from '@angular/core';
import { Types } from 'shared-lib';
import { v4 } from 'uuid';
import { TextComponent } from '../text/text.component';

@Component({
  selector: 'ui-list',
  standalone: true,
  imports: [NgFor, forwardRef(() => TextComponent), ListComponent],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
})
export class ListComponent implements OnInit {
  choice = model.required<Types.TChoice[]>();
  placeHolder = model.required<Types.TChoice>();
  value = model<Types.TChoice | Types.TChoice[] | undefined>();
  type = model(Types.EList.DROPDOWN);
  default = model<Types.TChoice | Types.TChoice[] | undefined>();
  required = input(false);
  editable = input(false);
  isTemplate = input(false);

  uiId = v4();
  Types = Types;

  listTypes = [
    Types.EList.CHECKBOX,
    Types.EList.DROPDOWN,
    Types.EList.RADIOBOX,
  ];

  constructor() {}

  ngOnInit(): void {
    if (!this.value() && this.default()) {
      this.value.set(this.default());
    }
  }

  // ZONA: isTemlpate

  onPlaceholderChange(inputValue?: Types.TChoice | Types.TChoice[]) {
    this.placeHolder.set(inputValue as Types.TChoice);
  }

  onTypeChange(inputValue?: Types.TChoice | Types.TChoice[]) {
    this.type.set(inputValue as Types.EList);
  }

  onChoiceChange(inputValue?: Types.TChoice | Types.TChoice[]) {
    this.choice.set((inputValue as string).split('\n'));
  }

  onDefaultChange(inputValue?: Types.TChoice | Types.TChoice[]) {
    this.default.set(inputValue);
    this.value.set(this.default());
  }

  // ZONA: isEditable

  onValueSelected(target?: any) {
    this.onValueChange(target.value, target);
  }

  onValueChange(id?: Types.TChoice | Types.TChoice[], target?: any) {
    const value = (
      this.isObject()
        ? (this.choice() as Types.TListChoice[]).filter(
            (item) => item.id == id
          )?.[0]
        : id
    ) as Types.TChoice;
    let oldValue = this.value();
    if (this.type() == Types.EList.CHECKBOX) {
      if (!Array.isArray(oldValue)) {
        oldValue = [];
      }
      const indice = oldValue.indexOf(value);
      if (indice !== -1) {
        oldValue.splice(indice, 1);
      }
      if (target.checked) {
        oldValue.push(value);
      }
    } else {
      oldValue = value;
    }
    this.value.set(oldValue);
  }

  resetValue() {
    this.value.set('');
  }

  // ZONA:

  hasMember(
    array: Types.TChoice | Types.TChoice[] | undefined | null,
    item: Types.TChoice | undefined
  ) {
    if (Array.isArray(array) && item) {
      return this.isObject()
        ? (array as Types.TListChoice[])
            .flatMap((item) => item.id)
            .includes((item as Types.TListChoice).id)
        : array.includes(item);
    }
    return false;
  }

  isObject() {
    const choice = this.choice();
    return (
      (Array.isArray(choice) &&
        choice.length > 0 &&
        typeof choice?.[0] === 'object' &&
        'id' in choice?.[0]) ||
      (typeof choice === 'object' && 'id' in choice)
    );
  }

  choiceList() {
    return this.isObject()
      ? (this.choice() as Types.TListChoice[]).flatMap((item) => item.name)
      : this.choice();
  }

  isChecked(item: Types.TChoice, value?: Types.TChoice | Types.TChoice[]) {
    if (!value) {
      return false;
    }
    return this.isObject()
      ? (item as Types.TListChoice).id == (value as Types.TListChoice).id
      : item == value;
  }

  getId(item?: Types.TChoice | Types.TChoice[]) {
    return this.isObject() && item ? (item as Types.TListChoice).id : item;
  }

  getName(item?: Types.TChoice | Types.TChoice[]) {
    return this.isObject() && item ? (item as Types.TListChoice).name : item;
  }
}
